export const ProtectedRoutes = ({ element }) => {
    const token  = localStorage.getItem("token");
return element;
    if (!token) {
        window.location = "/login"
    } else {
        return element;
    }
}